import { Fragment, FunctionalComponent, h } from 'preact';
import { Route, Router } from 'preact-router';

import NotFoundPage from '../routes/notfound';
import Header from './header';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { clearTokens, getAuthorization, getTokenGrants, initializeTokenManager } from '../services/token-service';
import Login from '../routes/login';
import { useState } from 'preact/hooks';
import Hardware from '../routes/hardware/index';
import Devices from '../routes/devices';
import Groups from '../routes/groups';
import Dashboard from '../routes/dashboard/index';
import { hardwareTypes } from '../types/hardware-type';

const App: FunctionalComponent = () => {
    const [grants, setGrants] = useState<string[] | undefined>(getTokenGrants());

    initializeTokenManager(setGrants);

    const logout = () => {
        clearTokens();
        setGrants(undefined);
    };

    const login = async (email?: string, password?: string) => {
        const emailRegex =
            /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

        if (!email) {
            toast("Email is required", { type: "error" });
            return;
        }
        email = email.trim();
        if (!emailRegex.test(email)) {
            toast("Email is invalid", { type: "error" });
            return;
        }

        if (!password) {
            toast("Password is required", { type: "error" });
            return;
        }
        if (password.length < 6) {
            toast("Password must be at least 6 characters", { type: "error" });
            return;
        }

        if (!(await getAuthorization(email, password))) {
            toast("Login failed", { type: "error" });
            return;
        }

        setGrants(getTokenGrants());
    };

    return (
        <div id="preact_root" class='bg-gray-800 overflow-x-auto'>
            { grants !== undefined
            ? 
            <>
                <Header logout={logout}/>
                <Router>
                    <Dashboard path="/"/>
                    <Devices path="/devices/"/>
                    <Groups path="/groups/"/>
                    {
                        hardwareTypes.map((hardwareType, i) => (
                            <Hardware key={i} path={`/${hardwareType}`} hardwareType={hardwareType}/>
                        ))
                    }
                    <NotFoundPage default />
                </Router>
            </>
            : <Login login={login}/>
            }
            
            <ToastContainer
                position='top-right'
                autoClose={4000}
                pauseOnHover
                theme='dark'
            />
        </div>
    );
};

export default App;
